export default __webpack_public_path__ + "static/zahnrad-7a5ce59092ebf70a5b38b5aaab3559ee.webp";